import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";

FilterModalHeader.propTypes = {
  title: PropTypes.string.isRequired,
  headerSx: PropTypes.object,
  titleId: PropTypes.string,
};

export function FilterModalHeader({ title, headerSx, titleId }) {
  return (
    <Box sx={headerSx}>
      <Box sx={{ width: 40 }} />
      <Typography
        id={titleId}
        component="h2"
        sx={{ fontWeight: 700, fontSize: 24 }}
      >
        {title}
      </Typography>
    </Box>
  );
}

export function FilterModalFooter({
  onCancel,
  onSubmit,
  leftLabel,
  rightLabel,
  ActionButton,
  cancelButtonSx,
  submitButtonSx,
}) {
  return (
    <Box sx={{ display: "flex", gap: 2, mx: 1 }}>
      <ActionButton
        onClick={onCancel}
        label={leftLabel}
        sx={{ bgcolor: "#D9D9D9", ...cancelButtonSx }}
      />
      <ActionButton
        onClick={onSubmit}
        label={rightLabel}
        sx={submitButtonSx}
      />
    </Box>
  );
}

FilterModalFooter.propTypes = {
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
  leftLabel: PropTypes.string,
  rightLabel: PropTypes.string,

  ActionButton: PropTypes.elementType.isRequired,

  cancelButtonSx: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.func]),
  submitButtonSx: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.func]),
};